import { render, staticRenderFns } from "./mobileRecord.vue?vue&type=template&id=ac06dcce&scoped=true&"
import script from "./mobileRecord.vue?vue&type=script&lang=js&"
export * from "./mobileRecord.vue?vue&type=script&lang=js&"
import style0 from "./mobileRecord.vue?vue&type=style&index=0&id=ac06dcce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac06dcce",
  null
  
)

export default component.exports